import * as Yup from "yup";

const WorkCategorySchema = Yup.object().shape({
  work_category_name: Yup.string().required("Work category name is required"),
  company_id: Yup.string().required("Company is required"),
});

export default WorkCategorySchema;
